import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const Imprintpartners = () => {
  const title = "{BRAND.product} partners with Folio3 AI to create a values-based social media platform, which will be at the forefront of online safety."

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>
            {title}
          </h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>News</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>
                  Published on December, 2023
                </p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                In December 2023, {BRAND.domainLabel} partnered with Folio3 AI to
                create a values-driven social media platform designed to lead
                the way under the UK&apos;s Online Safety Act.
              </p>

              <p>
                This collaboration set out to redefine digital engagement by
                enhancing content governance, scaling platform infrastructure,
                and delivering hyper-personalised user experiences — all while
                ensuring full compliance with evolving safety and regulatory
                standards.
              </p>

              <p>
                As a result of this strategic partnership, Folio3 AI and
                {BRAND.domainLabel} developed:
              </p>

              <ul>
                <li>
                  AI-Driven Moderation Framework — to proactively manage harmful
                  content and support safer interactions.
                </li>

                <li>
                  AI-Powered Virtual Assistant (Rudi) — offering users on-demand
                  guidance, support, and personalised interaction.
                </li>

                <li>
                  Flexible Subscription Engine — enabling scalable and
                  user-centric monetisation models.
                </li>

                <li>
                  Gamified Engagement Modules — designed to foster meaningful
                  participation and positive online behaviour.
                </li>

                <li>
                  Behavioural-Based Notifications — promoting mental well-being
                  and reducing anxiety triggers.
                </li>

                <li>
                  Advanced Moderation &amp; Reporting Dashboards — giving
                  administrators real-time insight and control.
                </li>
              </ul>

              <p>Key outcomes include:</p>

              <ul>
                <li>Improved content safety through advanced AI moderation.</li>
                <li>
                  Highly personalised user journeys tailored to individual needs
                  and behaviours.
                </li>
                <li>
                  Scalable infrastructure ready to support a diverse and growing
                  global community.
                </li>
                <li>
                  Full alignment with the regulatory and safety requirements set
                  by the Online Safety Act.
                </li>
              </ul>

              <p>
                This partnership represents a significant step toward building a
                new version of social media that puts user wellbeing and safety
                first.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Imprintpartners;
